function format (input: any, opt: any) {
    if (typeof input === 'number') {
        input = input.toFixed(opt.precision)
    }
    let negative = input.indexOf('-') >= 0 ? '-' : ''

    let numbers = onlyNumbers(input)
    let currency = numbersToCurrency(numbers, opt)
    let parts = toStr(currency).split('.')
    let integer = parts[0]
    let decimal = parts[1]
    integer = addThousandSeparator(integer, opt.thousands)
    return opt.prefix + negative + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix
}

function event (name: string) {
    let evt = document.createEvent('Event')
    evt.initEvent(name, true, true)
    return evt
}

function setCursor (el: any, position: any) {
    let setSelectionRange = function () {
        el.setSelectionRange(position, position)
    }
    if (el === document.activeElement) {
        setSelectionRange()
        setTimeout(setSelectionRange, 1) // Android Fix
    }
}

function assign (defaults: any, extras: any) {
    defaults = defaults || {}
    extras = extras || {}
    return Object.keys(defaults).concat(Object.keys(extras)).reduce(function (acc: any, val) {
        acc[val] = extras[val] === undefined ? defaults[val] : extras[val]
        return acc
    }, {})
}

function joinIntegerAndDecimal (integer: any, decimal: any, separator: string) {
    return decimal ? integer + separator + decimal : integer
}

function addThousandSeparator (integer: any, separator: string) {
    return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`)
}

function currencyToIntegerAndDecimal (float: number) {
    return toStr(float).split('.')
}

function unformat (input: any, opt: any) {
    let negative = input.indexOf('-') >= 0 ? -1 : 1
    let numbers = onlyNumbers(input)
    let currency: number = parseFloat(numbersToCurrency(numbers, opt))
    return currency * negative
}

function toStr (value: any) {
    return value ? value.toString() : ''
}

function onlyNumbers (input: string) {
    return toStr(input).replace(/\D+/g, '') || '0'
}

function between (min: number, n: number, max: number) {
    return Math.max(min, Math.min(n, max))
}

function numbersToCurrency (numbers: string, opt: any) {
    let exp = Math.pow(10, opt.precision)
    let float = parseFloat(numbers) / exp
    return float.toFixed(opt.precision)
}

export default {
    onlyNumbers,
    between,
    toStr,
    assign,
    addThousandSeparator,
    format,
    setCursor,
    unformat,
    joinIntegerAndDecimal,
    event
}
